import type {OrderItem, OrderStatus} from "../../api";

// Правила админского списка заявок, вынесенные из страницы отдельным модулем —
// ровно по той же причине, что и правила разбора спора рядом: их проверяет
// тест, а не глаз через интерфейс.

/**
 * Открытый USDT-этап заявки-обмена: рубли по заявке проведены, а перевод
 * клиенту ещё не подтверждён. Только в этом состоянии админу есть что закрывать
 * руками.
 *
 * Условие `status === "success"` здесь несущее, а не уточняющее. USDT-этап
 * открывается ТОЛЬКО успехом рублей: у заявки-обмена, по которой рубли ещё не
 * закрыты, строка второй ноги уже существует и её `payoutStatus` — `pending`,
 * поэтому без этого условия метка и кнопка загорались бы на живой заявке, а
 * сервер отвечал бы на клик отказом `rub_not_confirmed`. Ровно то же условие
 * стоит на сервере, и расходиться им нельзя.
 */
export function exchangePayoutOpen(item: OrderItem): boolean {
    if (item.status !== "success") return false;
    return item.exchangePayoutStatus != null && item.exchangePayoutStatus !== "confirmed";
}

/**
 * The appeal flag can outlive the terminal order transition until the worker
 * clears it. Terminal state is the authoritative display; an active appeal
 * still overrides the ordinary active status.
 */
export function displayedOrderStatus(status: OrderStatus, appeal: boolean): OrderStatus {
    if (status === "success" || status === "cancelled") return status;
    return appeal ? "appeal" : status;
}

/**
 * Вердикт находки человеческими словами.
 *
 * Английский маркер приходит с сервера и остаётся ключом; админ читает
 * таблицу глазами, и «amount_mismatch» ему в ней ничего не объясняет.
 */
export function observedVerdictLabel(verdict: string): string {
    switch (verdict) {
        case "matched":
            return "сошлось";
        case "amount_mismatch":
            return "сумма не та";
        case "before_window":
            return "до окна";
        case "after_window":
            return "после окна";
        case "duplicate":
            return "повтор";
        default:
            return verdict;
    }
}
